// 监听目标元素出现在可视区域
export const target = {
  mounted(el, binding) {
    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        const origin = document.querySelector(`[data-id=${el.id}]`);
        // console.log("entry=", entry);
        // console.log("data-id=", `[data-id=${el.id}]`);
        if (entry.isIntersecting) {
          // console.log("entry.isIntersecting=", entry.isIntersecting);
          origin.classList.add("chss-basic-active"); // 改变背景颜色
          const parent = origin.parentNode.parentNode;
          const els: any = parent.querySelectorAll(`[data-id]`);
          for (let child of els) {
            if (child !== origin) {
              // 取消其他背景
              child.classList.remove("chss-basic-active");
            }
          }
          // observer.unobserve(entry.target); // 取消监听
        } else {
          // origin.classList.remove("chss-basic-active");
        }
      });
    }
    const options = {
      root: null, // 视口
      threshold: 0.5 // 交集比例阈值
    };
    const observer = new IntersectionObserver(handleIntersection, options);
    const target = document.getElementById(el.id);
    if (target) {
      observer.observe(target);
      el.observer = observer;
    }
  },
  beforeUnmount(el) {
    // 取消监听
    const target = document.getElementById(el.id);
    if (target) {
      el.observer.unobserve(target);
    }
  }
};
